import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const eocOverviewAllTeamsRoute: InvariantJiraRoute = {
	name: 'eoc-overview-all-teams',
	path: '/jira/ops/overview/teams',
	exact: true,
};
